var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileMatcha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 37 31",
    style: {
      enableBackground: "new 0 0 37 31"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#01C482;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18,23.8c-0.3,0.3-0.8,0.3-1.1,0l-2.4-2.1c-0.5-0.5-1.4-0.1-1.4,0.6v7.5c0,0.5-0.4,0.8-0.8,0.8H0.8 c-0.5,0-0.8-0.4-0.8-0.8v-29C0,0.4,0.4,0,0.8,0h12.5c0.3,0,0.6,0.2,0.7,0.5l2.7,5.3c0.3,0.6,1.2,0.6,1.5,0l2.7-5.3 C21.2,0.2,21.5,0,21.8,0h14.3C36.6,0,37,0.4,37,0.8v29c0,0.5-0.4,0.8-0.8,0.8H22.7c-0.5,0-0.8-0.4-0.8-0.8v-7.5 c0-0.7-0.9-1.1-1.4-0.6L18,23.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMatcha);
export default __webpack_public_path__ + "static/media/MOBILE_MATCHA.3f852de9a71ef4690aaf226a9622ae4c.svg";
export { ForwardRef as ReactComponent };